import React, {useState, useEffect} from 'react'
import {DateUtils} from 'react-day-picker'
import {Modal} from 'antd'
import Card from 'components/shared/Card'
import OrderNavigation from 'components/shared/OrderNavigation'
import DayPicker from 'components/shared/DayPicker'
import ShowResultsForDate from './ShowResultsForDate'
import './index.scss'

const SelfBooking = ({
  productSelection,
  webOrder,
  goToNextStep,
  goToPreviousStep,
  productSelectionReducer,
  isFetchingBill,
  updateError
}) => {
  let defaultDate = null
  const reservedBooking = webOrder.reservedBooking
  if (reservedBooking) {
    defaultDate = new Date(reservedBooking.startsAt)
  }

  const [date, setDate] = useState(defaultDate)
  const [selectedBooking, setSelectedBooking] = useState()

  const dayPickerModifiers = {}
  if (reservedBooking && reservedBooking.startsAt) {
    // Add a unique css class name (reservedBooking) for the reserved day
    dayPickerModifiers.reservedBooking = new Date(reservedBooking.startsAt)
  }

  useEffect(() => {
    if (updateError) {
      Modal.error({
        title: 'Denne tiden er ikke lenger tilgjengelig',
        content: (
          <div>
            <p>Last siden på nytt for å få en oppdatert liste over tilgjengelige tider.</p>
          </div>
        ),
      })
    }
  }, [updateError])

  const setReservedBooking = (reservedBooking) => {
    setSelectedBooking(reservedBooking)
    productSelectionReducer({type: 'setReservedBooking', reservedBooking})
  }

  return (
    <>
      Velg dato
      <Card className="date-picker-card">
        <DayPicker
          className="large"
          modifiers={dayPickerModifiers}
          selectedDays={date}
          disabledDays={day => !DateUtils.isFutureDay(day)}
          onDayClick={(date, {disabled}) => {
            if (!disabled) {
              setDate(date)
            }
          }}
        />
      </Card>

      {!!date && (
        <ShowResultsForDate
          date={date}
          webOrder={webOrder}
          selectedBooking={isFetchingBill ? (selectedBooking || reservedBooking) : null}
          reservedBooking={reservedBooking}
          setReservedBooking={setReservedBooking}
        />
      )}

      <OrderNavigation
        onBack={goToPreviousStep}
        onNext={goToNextStep}
        nextButtonProps={{
          disabled: !reservedBooking,
        }}
      />
    </>
  )
}

export default SelfBooking
